import "./style.css"; // 引入 css

import React, { useState, useEffect } from "react";
import { Editor, Toolbar } from "@wangeditor/editor-for-react";
import { IMG_BASE_URL } from "src/config/constants";
import ImagePicker from "../common/ImagePicker";

function MyEditor({ html, onChange, mobile = true }) {
  const [editor, setEditor] = useState(null); // 存储 editor 实例

  const toolbarConfig = {};
  const editorConfig = {
    autoFocus: false,
    placeholder: "请输入内容...",
    MENU_CONF: {
      fontSize: {
        fontSizeList: [
          '12px', '14px', '16px', '18px', '20px', '22px', '24px', '30px', '32px',
        ]
      },
      lineHeight: {
        lineHeightList: ['1', '1.5', '1.8', '2', '2.5'],
      },
      // insertImage: {
      //   onInsertedImage(imageNode) {                    // JS 语法
      //     if (imageNode == null) return

      //     imageNode.style.width = '100%';
      //     const { src, alt, url, href } = imageNode
      //     console.log('inserted image', src, alt, url, href)
      //   }
      // },
      uploadImage: {
        async customBrowseAndUpload(insertFn) {
          ImagePicker({
            multiple: true,
            onSelect(val) {
              val.split(',').forEach(v => {
                insertFn(`${IMG_BASE_URL}${v}`, '', '')
              })
              // insertFn(url, alt, href)
            }
          })

        }
      }
    },
  };

  // 及时销毁 editor ，重要！
  useEffect(() => {
    return () => {
      if (editor == null) return;
      editor.destroy();
      setEditor(null);
    };
  }, [editor]);

  return (
    <>
      <div style={{
        border: "1px solid #ccc",
        zIndex: 100
      }}>
        <Toolbar editor={editor} defaultConfig={toolbarConfig} mode="default" style={{ borderBottom: "1px solid #ccc" }} />
        <Editor
          defaultConfig={editorConfig}
          value={html}
          onCreated={setEditor}
          onChange={(editor) => {
            onChange(editor.getHtml());
          }}
          mode="default"
          style={{
            maxHeight: 800,
            height: 500,
            minHeight: 500,
            overflowX: 'hidden',
            overflowY: "auto"
          }}
        />
      </div>
    </>
  );
}

export default MyEditor;
